import { DialogActions, Button } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import styles from './styles.module.scss';
import { TKeys } from 'utils/enums';

interface DialogButtonsProps {
    onClose: () => void;
    cancelLabel?: string;
    submitLabel?: string;
    onSubmit?: () => void;
    disabled?: boolean;
}

export default function DialogButtons(props: DialogButtonsProps) {
    return (
        <DialogActions>
            <Button onClick={props.onClose} className={styles.formButton} aria-label="Cancel">
                {props.cancelLabel ? props.cancelLabel : t(TKeys.BTN000016)}
            </Button>
            <Button
                type="submit"
                aria-label="Submit"
                className={styles.formButton}
                onClick={props.onSubmit && props.onSubmit}
                disabled={props.disabled}>
                {props.submitLabel ? props.submitLabel : t(TKeys.BTN000017)}
            </Button>
        </DialogActions>
    );
}
